import { FeatureFlagContext } from "components/FeatureFlagProvider";
import { useContext } from "react";

export const useFeatureFlag = <T>(
  flagName: string,
  defaultValue: T
): [boolean | string, T] => {
  const { ldClient } = useContext(FeatureFlagContext);
  return [
    !ldClient, // isLoading
    ldClient ? ldClient.variation(flagName, defaultValue) : defaultValue
  ];
};
